import type { z } from "zod";
import type {
    MonthlySales} from "./monthly-reports/monthly-sales";
import {
    monthlySalesZodSchema,
} from "./monthly-reports/monthly-sales";
import type { SettlementNote } from "./settlement-notes/settlement-note";

type Report = SettlementNote | MonthlySales;

const reportZodSchema: z.ZodSchema<Report> = monthlySalesZodSchema;

export type { Report };
export { reportZodSchema };
